import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=878c9df8"
import script from "./Notifications.ts?vue&type=script&lang=js&external"
export * from "./Notifications.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports